import { memo, NamedExoticComponent } from 'react';

import { Content, Sidebar, Toolbar } from './components';
import { Root } from './PageWrapper.styles';
import { ChildrenComponents, PageWrapperProps } from './PageWrapper.types';

/**
 * Add base styles for the page
 */
const PageWrapper = memo((props) => {
    const { direction = 'column', color = 'white100', children, ...restProps } = props;

    return (
        <Root $direction={direction} $color={color} {...restProps}>
            {children}
        </Root>
    );
}) as NamedExoticComponent<PageWrapperProps> & ChildrenComponents;

PageWrapper.Toolbar = Toolbar;
PageWrapper.Content = Content;
PageWrapper.Sidebar = Sidebar;

export default PageWrapper;
